import React, { Component, PropTypes } from 'react';
import { Provider } from 'react-redux';
import { ReduxRouter } from 'redux-simple-router';
import { Router } from 'react-router';
import applyMiddleware from 'react-router-apply-middleware';
import { useRelativeLinks } from 'react-router-relative-links';

module.exports = React.createClass({
	displayName: 'Root',

	propTypes: {
		history: PropTypes.object.isRequired,
		routes: PropTypes.func.isRequired,
		store: PropTypes.object.isRequired
	},

	render() {
		const { store } = this.props;
		return (
			<Provider store={ store }>
				<div className="root-container">
					<Router history={ this.props.history } render={ applyMiddleware(useRelativeLinks()) }>
						{this.props.routes(store)}
					</Router>
				</div>
			</Provider>
		);
	}
});



// WEBPACK FOOTER //
// ./frontend/olos/js/containers/Root.prod.jsx